export const FormFields = {
    name: 'name',
};
